import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _toConsumableArray from "@babel/runtime-corejs3/helpers/toConsumableArray";
import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
var _excluded = ["id", "children", "multi", "searchable", "deselectable", "freeform", "items", "value", "selectedItem", "initialSelectedItem", "initialSelectedItems", "filter", "normaliser", "getItemId", "itemToString"];

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) { symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context6; _forEachInstanceProperty(_context6 = ownKeys(Object(source), true)).call(_context6, function (key) { _defineProperty(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { var _context7; _forEachInstanceProperty(_context7 = ownKeys(Object(source))).call(_context7, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

import _Map from "@babel/runtime-corejs3/core-js-stable/map";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/includes";
import _reduceInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/reduce";
import _findInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/find";

/* eslint-disable max-lines */
import React, { useRef, useMemo, useState, useCallback, useEffect, createContext } from 'react';
import { useDownshift } from '../hooks/use-downshift';
import { useDerivedSelectedItem } from '../hooks/use-derived-selected-item';
import { defaultItems, defaultNormaliser, defaultItemToString, defaultGetItemId, defaultFilter } from '../utils/defaults';
import { noop, reduce, groupBy, capitalize, startCase } from 'lodash';
export var SelectContext = /*#__PURE__*/createContext({
  id: '',
  multi: false,
  searchable: true,
  deselectable: false,
  menuOpenOnFocus: {
    current: true
  },
  filterInputValue: '',
  items: [],
  itemMap: new _Map(),
  selectedItem: null,
  selectedItems: [],
  getItemId: defaultGetItemId,
  deselectItem: noop,
  selectItemExternal: noop,
  isOpen: false,
  highlightedIndex: 0,
  inputValue: '',
  reset: noop,
  itemToString: defaultItemToString,
  openMenu: noop,
  closeMenu: noop,
  selectItem: noop,
  setInputValue: noop,
  getToggleButtonProps: noop,
  getComboboxProps: noop,
  getMenuProps: noop,
  getInputProps: noop,
  getItemProps: noop,
  setScrollToIndex: noop
});
var Provider = SelectContext.Provider;
export function SelectProvider(_ref) {
  var id = _ref.id,
      children = _ref.children,
      _ref$multi = _ref.multi,
      multi = _ref$multi === void 0 ? false : _ref$multi,
      _ref$searchable = _ref.searchable,
      searchable = _ref$searchable === void 0 ? true : _ref$searchable,
      _ref$deselectable = _ref.deselectable,
      deselectable = _ref$deselectable === void 0 ? false : _ref$deselectable,
      freeform = _ref.freeform,
      _ref$items = _ref.items,
      propItems = _ref$items === void 0 ? defaultItems : _ref$items,
      value = _ref.value,
      propSelectedItem = _ref.selectedItem,
      _ref$initialSelectedI = _ref.initialSelectedItem,
      propInitialSelectedItem = _ref$initialSelectedI === void 0 ? null : _ref$initialSelectedI,
      _ref$initialSelectedI2 = _ref.initialSelectedItems,
      propInitialSelectedItems = _ref$initialSelectedI2 === void 0 ? [] : _ref$initialSelectedI2,
      _ref$filter = _filterInstanceProperty(_ref),
      filter = _ref$filter === void 0 ? defaultFilter : _ref$filter,
      _ref$normaliser = _ref.normaliser,
      normaliser = _ref$normaliser === void 0 ? defaultNormaliser : _ref$normaliser,
      _ref$getItemId = _ref.getItemId,
      getItemId = _ref$getItemId === void 0 ? defaultGetItemId : _ref$getItemId,
      _ref$itemToString = _ref.itemToString,
      itemToString = _ref$itemToString === void 0 ? defaultItemToString : _ref$itemToString,
      props = _objectWithoutProperties(_ref, _excluded);

  var menuOpenOnFocus = useRef(true);
  var freeformItems = useRef([]);
  var itemMap = useRef(new _Map());

  var _useState = useState(''),
      _useState2 = _slicedToArray(_useState, 2),
      filterInputValue = _useState2[0],
      setFilterInputValue = _useState2[1];

  var _useDerivedSelectedIt = useDerivedSelectedItem({
    itemMap: itemMap.current,
    value: value,
    selectedItem: propSelectedItem,
    initialSelectedItem: propInitialSelectedItem,
    initialSelectedItems: propInitialSelectedItems,
    normaliser: normaliser,
    getItemId: getItemId
  }),
      controlSelectedItem = _useDerivedSelectedIt.selectedItem,
      controlSelectedItems = _useDerivedSelectedIt.selectedItems,
      initialSelectedItem = _useDerivedSelectedIt.initialSelectedItem,
      initialSelectedItems = _useDerivedSelectedIt.initialSelectedItems;

  var _useState3 = useState(initialSelectedItems),
      _useState4 = _slicedToArray(_useState3, 2),
      selectedItems = _useState4[0],
      setSelectedItems = _useState4[1];

  var normalisedItems = useMemo(function () {
    return _mapInstanceProperty(propItems).call(propItems, function (item) {
      return normaliser(item);
    });
  }, [propItems, normaliser]);
  var filteredItems = useMemo(function () {
    return _filterInstanceProperty(normalisedItems).call(normalisedItems, function (item) {
      return filter(item, {
        selectedItems: selectedItems,
        itemToString: itemToString,
        inputValue: filterInputValue
      });
    });
  }, [normalisedItems, filterInputValue, selectedItems, filter, itemToString]); // Because we're virtualising the list, we need the headings
  // to be a part of the items we're rendering so that we
  // can pass them to 'react-virtual'
  // If we try to add these items (in the menu component) without
  // downshift knowing about them then we can't imperatively scroll
  // to the correct index in the virtualised list because the
  // index of the grouped items and the index of the downshift items
  // won't match up properly and the menu starts jumping around

  var itemsWithHeadings = useMemo(function () {
    return reduce(groupBy(filteredItems, 'type'), function (acc, items, type) {
      var _context2;

      // The groupBy function will put all items without a
      // type in the 'undefined' (string) key
      if (type !== 'undefined') {
        var _context, _items$0$heading;

        acc = _concatInstanceProperty(_context = []).call(_context, _toConsumableArray(acc), [{
          type: type,
          isHeading: true,
          // Use the configuration of the first item in the list
          heading: (_items$0$heading = items[0].heading) !== null && _items$0$heading !== void 0 ? _items$0$heading : capitalize(startCase(type)),
          HeadingIcon: items[0].HeadingIcon
        }]);
      }

      return _concatInstanceProperty(_context2 = []).call(_context2, _toConsumableArray(acc), _toConsumableArray(items));
    }, []);
  }, [filteredItems]);
  var addFreeformItem = useCallback(function (item) {
    var _context3;

    var normalisedItem = normaliser(item);
    itemMap.current.set(getItemId(normalisedItem), {
      item: item,
      normalisedItem: normalisedItem
    }); // Add this item if it doesn't already exist

    if (!_includesInstanceProperty(_context3 = freeformItems.current).call(_context3, item)) {
      freeformItems.current.push(item);
    }
  }, [normaliser, getItemId]);

  var _useDownshift = useDownshift(_objectSpread(_objectSpread({}, props), {}, {
    id: id,
    multi: multi,
    items: itemsWithHeadings,
    selectedItem: controlSelectedItem,
    initialSelectedItem: initialSelectedItem,
    initialSelectedItems: initialSelectedItems,
    itemMap: itemMap.current,
    normaliser: normaliser,
    getItemId: getItemId,
    itemToString: itemToString,
    setFilterInputValue: setFilterInputValue,
    setSelectedItems: setSelectedItems
  })),
      isOpen = _useDownshift.isOpen,
      highlightedIndex = _useDownshift.highlightedIndex,
      inputValue = _useDownshift.inputValue,
      selectedItem = _useDownshift.selectedItem,
      downshiftReset = _useDownshift.reset,
      openMenu = _useDownshift.openMenu,
      closeMenu = _useDownshift.closeMenu,
      selectItem = _useDownshift.selectItem,
      setInputValue = _useDownshift.setInputValue,
      getToggleButtonProps = _useDownshift.getToggleButtonProps,
      getComboboxProps = _useDownshift.getComboboxProps,
      getMenuProps = _useDownshift.getMenuProps,
      getInputProps = _useDownshift.getInputProps,
      getItemProps = _useDownshift.getItemProps,
      setScrollToIndex = _useDownshift.setScrollToIndex; // We have some custom state to reset as well as the downshift reset


  var reset = useCallback(function () {
    downshiftReset();
    setFilterInputValue('');
  }, [downshiftReset]);
  var deselectItem = useCallback(function (item) {
    if (multi) {
      // HACK: We are relying on the multi select logic in the
      // state reducer here, where re-selecting any item
      // that's currently selected will deselect it
      selectItem(item);
    } else {
      selectItem(null);
    }
  }, [multi, selectItem]); // For consumers of the select we want them to be able to select
  // items using the 'Item' type instead of the 'NormalisedItem' type
  // so we let them send an item here and normalise it ourselves

  var selectItemExternal = useCallback(function (newItem) {
    var normalisedNewItem = normaliser(newItem);
    addFreeformItem(newItem);
    selectItem(normalisedNewItem); // Reset the filter input value because it is most likely
    // that the user didn't find what they were looking for
    // in the list if they are adding the value themselves

    setFilterInputValue('');
  }, [addFreeformItem, selectItem, normaliser]);
  var context = useMemo(function () {
    return {
      // Custom props
      id: id,
      multi: multi,
      searchable: searchable,
      deselectable: deselectable,
      freeform: freeform,
      menuOpenOnFocus: menuOpenOnFocus,
      filterInputValue: filterInputValue,
      items: itemsWithHeadings,
      itemMap: itemMap.current,
      selectedItem: selectedItem,
      selectedItems: selectedItems,
      getItemId: getItemId,
      deselectItem: deselectItem,
      selectItemExternal: selectItemExternal,
      // Use combobox
      isOpen: isOpen,
      highlightedIndex: highlightedIndex,
      inputValue: inputValue,
      reset: reset,
      itemToString: itemToString,
      openMenu: openMenu,
      closeMenu: closeMenu,
      selectItem: selectItem,
      setInputValue: setInputValue,
      getToggleButtonProps: getToggleButtonProps,
      getComboboxProps: getComboboxProps,
      getMenuProps: getMenuProps,
      getInputProps: getInputProps,
      getItemProps: getItemProps,
      setScrollToIndex: setScrollToIndex
    };
  }, [id, multi, searchable, deselectable, freeform, menuOpenOnFocus, filterInputValue, itemsWithHeadings, selectedItem, selectedItems, getItemId, deselectItem, selectItemExternal, isOpen, highlightedIndex, inputValue, reset, itemToString, openMenu, closeMenu, selectItem, setInputValue, getToggleButtonProps, getComboboxProps, getMenuProps, getInputProps, getItemProps, setScrollToIndex]);
  useEffect(function () {
    // If we are controlling the value or selectedItem from
    // outside the select we need to be reflecting these
    // changes in our internal state
    if (controlSelectedItems) {
      setSelectedItems(controlSelectedItems);
    }
  }, [controlSelectedItems]);
  useEffect(function () {
    var _context4, _context5;

    // Add the new items to our item map when we get them
    // overriding any that already exist in case the normaliser
    // changes or if different items have the same id
    itemMap.current = _reduceInstanceProperty(_context4 = _concatInstanceProperty(_context5 = []).call(_context5, _toConsumableArray(propItems), _toConsumableArray(freeformItems.current))).call(_context4, function (acc, item) {
      // Make sure we always get the normalised items from
      // the same place instead of using a newly normalised
      // item so that equality checks are accurate
      var normalisedItem = _findInstanceProperty(normalisedItems).call(normalisedItems, function (normalisedItem) {
        return getItemId(normalisedItem) === getItemId(normaliser(item));
      });

      acc.set(getItemId(normalisedItem), {
        item: item,
        normalisedItem: normalisedItem
      });
      return acc;
    }, itemMap.current);
  }, [propItems, normalisedItems, normaliser, getItemId]);
  return /*#__PURE__*/React.createElement(Provider, {
    value: context
  }, children);
}